import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import QueryParkingStatuses from 'graphql/queries/QueryParkingStatuses'

const FetchParkingStatuses = {
	
	fetchAll: ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'parking_statuses', QueryParkingStatuses, {
			//instant: true,
			resultPath: [ 'parking_statuses' ],
			callbackStart,
			callbackError,
			callbackSuccess,
		})
	}
}

export default FetchParkingStatuses
